import { graphql, navigate, PageProps } from "gatsby";
import React, { useEffect, useState } from "react";

import MENU_PATHS from "../../constants/menu";

import { Layout, Pagination } from "../../components";
import { INews } from "../../interfaces/news";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import { BoxButton } from "../../components/buttons";
import SEO from "../../components/seo/SEO";

interface PageData {
  allPrismicNews: {
    nodes: INews[];
  };
}

const NewsListTemplate: React.FC<PageProps<PageData>> = ({
  data,
  pageContext,
}) => {
  const { numPages, currentPage: pageContextCurrentPage } = pageContext; 
  const [currentPage, setCurrentPage] = useState(pageContextCurrentPage);
  const [pageInitialized, setPageInitialized] = useState(false);

  const { allPrismicNews } = data || {};
  const { nodes } = allPrismicNews || [];

  useEffect(() => {
    if (!pageInitialized) {
      return;
    }
    const path = currentPage > 1 ? `${currentPage}/` : "";
    navigate(`${MENU_PATHS.NEWS}/${path}`);
  }, [currentPage]);

  useEffect(() => {
    setPageInitialized(true);
  }, []);
  const seo = {
    title: `SND | News`,
    pathname: MENU_PATHS.NEWS,
  };
  
  return (
    <div>
      <Layout height={720} stores={false} news>
        <SEO {...seo} />
        <Breadcrumbs
          breadcrumbs={[
            {
              id: 1,
              label: "Home",
              to: MENU_PATHS.HOMEPAGE,
              home: true,
            },
            {
              id: 2,
              label: "News",
              to: MENU_PATHS.NEWS,
            },
          ].filter((item) => item)}
        />
        <div className="overWidth">
          <div className="_wr">
            <div className="_w">
              <div className="-boxes spacing-50 _12 -newsBoxes">
                {nodes?.map((node: INews, index) => (
                  <BoxButton
                    id={index}
                    key={node.uid}
                    title={node.data?.title?.text || ""}
                    backgroundImage={node.data?.listing_image?.gatsbyImageData ? node.data?.listing_image : node.data?.cover_image}
                    description={node.data?.short_description?.text || ""}
                    uri={node.uid}
                    date={node.data?.date}
                    tags={node.tags}
                    boxNumber={3}
                  />
                ))}

                <Pagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalPages={numPages}
                />
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
};

export const query = graphql`
  query ($skip: Int!, $limit: Int!) {
    allPrismicNews(sort: { data: { date: DESC } }, limit: $limit, skip: $skip) {
      nodes {
        uid
        tags
        data {
          title {
            text
          }
          cover_image {
            alt
            copyright
            url
            gatsbyImageData
          }
          listing_image {
            alt
            copyright
            url
            gatsbyImageData
          }
          short_description {
            text
          }
          date(formatString: "MMMM D, YYYY")
        }
      }
    }
  }
`;

export default NewsListTemplate;
